(function() {
  const slideshow = document.querySelector('.slideshow');
  if (!slideshow) return;

  const slidesContainer = slideshow.querySelector('[data-slideshow-slides]');
  const originalSlides = Array.from(slidesContainer.children);
  const prevBtn = slideshow.querySelector('[data-slideshow-prev]');
  const nextBtn = slideshow.querySelector('[data-slideshow-next]');
  const dots = document.querySelectorAll('[data-slideshow-dot]');
  
  if (originalSlides.length <= 1) return;

  let currentIndex = 1; // クローンを追加するため1から開始
  let autoplayInterval;
  const autoplaySpeed = parseInt(slideshow.dataset.autoplaySpeed) || 5000;
  let isTransitioning = false;

  // 無限ループのためにクローンを作成
  const firstClone = originalSlides[0].cloneNode(true);
  const lastClone = originalSlides[originalSlides.length - 1].cloneNode(true);
  
  slidesContainer.appendChild(firstClone);
  slidesContainer.insertBefore(lastClone, originalSlides[0]);

  const allSlides = Array.from(slidesContainer.children);
  const totalSlides = allSlides.length;
  const realSlidesCount = originalSlides.length;

  function getSlideWidth() {
    return allSlides[0].offsetWidth;
  }

  function getGap() {
    const styles = window.getComputedStyle(slidesContainer);
    const gap = styles.gap || '0px';
    return parseFloat(gap);
  }

  function updateSlidePosition(instant = false) {
    const slideWidth = getSlideWidth();
    const gap = getGap();
    const slideshow = document.querySelector('.slideshow');
    const slideshowWidth = slideshow.offsetWidth;
    
    // 画面中央にスライドを配置するための計算
    const centerOffset = (slideshowWidth - slideWidth) / 2;
    const offset = centerOffset - (currentIndex * (slideWidth + gap));
    
    if (instant) {
      slidesContainer.style.transition = 'none';
    } else {
      slidesContainer.style.transition = 'transform 0.45s ease';
    }
    
    slidesContainer.style.transform = `translateX(${offset}px)`;
  }

  function updateDots() {
    // 実際のスライドインデックス（クローンを除く）
    let realIndex = currentIndex - 1;
    if (realIndex < 0) realIndex = realSlidesCount - 1;
    if (realIndex >= realSlidesCount) realIndex = 0;

    dots.forEach((dot, index) => {
      if (index === realIndex) {
        dot.classList.add('is-active');
      } else {
        dot.classList.remove('is-active');
      }
    });
  }

  function handleTransitionEnd() {
    isTransitioning = false;
    
    // 最初のクローンに到達したら、実際の最初のスライドにジャンプ
    if (currentIndex === 0) {
      currentIndex = realSlidesCount;
      updateSlidePosition(true);
    }
    // 最後のクローンに到達したら、実際の最後のスライドにジャンプ
    else if (currentIndex === totalSlides - 1) {
      currentIndex = 1;
      updateSlidePosition(true);
    }
  }

  function goToSlide(newIndex) {
    if (isTransitioning) return;
    
    isTransitioning = true;
    currentIndex = newIndex;
    
    updateSlidePosition();
    updateDots();
    
    // フォールバック: 一定時間後に強制リセット
    setTimeout(() => {
      isTransitioning = false;
    }, 1000);
  }

  function nextSlide() {
    goToSlide(currentIndex + 1);
  }

  function prevSlide() {
    goToSlide(currentIndex - 1);
  }

  function startAutoplay() {
    stopAutoplay();
    autoplayInterval = setInterval(nextSlide, autoplaySpeed);
  }

  function stopAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
    }
  }

  // スライダーの状態をリフレッシュする関数
  function refreshSlider() {
    // 現在の位置を維持しながら表示を更新
    updateSlidePosition(true);
    updateDots();
    
    // 一瞬待ってから再描画（ブラウザの最適化対策）
    requestAnimationFrame(() => {
      updateSlidePosition(true);
    });
  }

  // トランジション終了イベント
  slidesContainer.addEventListener('transitionend', handleTransitionEnd);

  // イベントリスナー
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      prevSlide();
      startAutoplay();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      nextSlide();
      startAutoplay();
    });
  }

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const index = parseInt(dot.dataset.slideshowDot);
      goToSlide(index + 1); // クローン分をオフセット
      startAutoplay();
    });
  });

  // ホバーでオートプレイ停止（PCのみ）
  if (window.innerWidth > 750) {
    slideshow.addEventListener('mouseenter', stopAutoplay);
    slideshow.addEventListener('mouseleave', startAutoplay);
  }

  // タッチイベント（スワイプ対応）
  let touchStartX = 0;
  let touchEndX = 0;
  let touchStartY = 0;
  let touchEndY = 0;

  slideshow.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
    touchStartY = e.changedTouches[0].screenY;
  }, { passive: true });

  slideshow.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    touchEndY = e.changedTouches[0].screenY;
    handleSwipe();
  }, { passive: true });

  function handleSwipe() {
    const swipeThreshold = 25; // スワイプと判定する最小距離
    const deltaX = touchEndX - touchStartX;
    const deltaY = touchEndY - touchStartY;

    // 縦スクロールの方が大きい場合はスワイプ判定しない
    if (Math.abs(deltaY) > Math.abs(deltaX)) {
      return;
    }

    // 左スワイプ（次へ）
    if (deltaX < -swipeThreshold) {
      nextSlide();
      startAutoplay();
    }
    // 右スワイプ（前へ）
    else if (deltaX > swipeThreshold) {
      prevSlide();
      startAutoplay();
    }
  }

  // リサイズ対応
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      updateSlidePosition(true);
    }, 100);
  });

  // Page Visibility API - タブの表示状態を監視
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      // タブが非表示になった時：autoplayを停止
      stopAutoplay();
    } else {
      // タブが表示された時：スライダーをリフレッシュしてautoplayを再開
      refreshSlider();
      startAutoplay();
    }
  });

  // ページがフォーカスを取り戻した時の対応
  window.addEventListener('focus', () => {
    if (!document.hidden) {
      refreshSlider();
      startAutoplay();
    }
  });

  // ページがフォーカスを失った時の対応
  window.addEventListener('blur', () => {
    stopAutoplay();
  });

  // 初期化
  updateDots();
  updateSlidePosition(true);
  startAutoplay();
})();
